const Channel = () => import('@/views/main/live/channel/Channel.vue')
export default {
  path: '/main/live/channel',
  name: 'Channel',
  component: Channel,
  children: []
}
